/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientCategories } from 'app/entities/patient-category/patient-category.reducer';
import { getEntities as getMiscCharges } from 'app/entities/misc-charges/misc-charges.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { createEntity, getEntity, reset, updateEntity } from './hosp-patient-cat-misc-charges.reducer';

export const HospPatientCatMiscChargesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientCategories = useAppSelector(state => state.patientCategory.entities);
  const miscCharges = useAppSelector(state => state.miscCharges.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const hospPatientCatMiscChargesEntity = useAppSelector(state => state.hospPatientCatMiscCharges.entity);
  const loading = useAppSelector(state => state.hospPatientCatMiscCharges.loading);
  const updating = useAppSelector(state => state.hospPatientCatMiscCharges.updating);
  const updateSuccess = useAppSelector(state => state.hospPatientCatMiscCharges.updateSuccess);

  const handleClose = () => {
    navigate(`/hosp-patient-cat-misc-charges${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientCategories({}));
    dispatch(getMiscCharges({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.multiplier !== undefined && typeof values.multiplier !== 'number') {
      values.multiplier = Number(values.multiplier);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.chargeAmount !== undefined && typeof values.chargeAmount !== 'number') {
      values.chargeAmount = Number(values.chargeAmount);
    }
    if (values.taxPercent !== undefined && typeof values.taxPercent !== 'number') {
      values.taxPercent = Number(values.taxPercent);
    }
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }

    const entity = {
      ...hospPatientCatMiscChargesEntity,
      ...values,
      patientCategory: patientCategories.find(it => it.id.toString() === values.patientCategory?.toString()),
      charge: miscCharges.find(it => it.id.toString() === values.charge?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...hospPatientCatMiscChargesEntity,
          patientCategory: hospPatientCatMiscChargesEntity?.patientCategory?.id,
          charge: hospPatientCatMiscChargesEntity?.charge?.id,
          hospital: hospPatientCatMiscChargesEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.hospPatientCatMiscCharges.home.createOrEditLabel" data-cy="HospPatientCatMiscChargesCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.home.createOrEditLabel">
              Create or edit a HospPatientCatMiscCharges
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="hosp-patient-cat-misc-charges-id"
                  label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.multiplier')}
                id="hosp-patient-cat-misc-charges-multiplier"
                name="multiplier"
                data-cy="multiplier"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.multiplierFlag')}
                id="hosp-patient-cat-misc-charges-multiplierFlag"
                name="multiplierFlag"
                data-cy="multiplierFlag"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.active')}
                id="hosp-patient-cat-misc-charges-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.cursor')}
                id="hosp-patient-cat-misc-charges-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.lastUpdated')}
                id="hosp-patient-cat-misc-charges-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.microSec')}
                id="hosp-patient-cat-misc-charges-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.timestampEntry')}
                id="hosp-patient-cat-misc-charges-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.chargeAmount')}
                id="hosp-patient-cat-misc-charges-chargeAmount"
                name="chargeAmount"
                data-cy="chargeAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.taxPercent')}
                id="hosp-patient-cat-misc-charges-taxPercent"
                name="taxPercent"
                data-cy="taxPercent"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.startDate')}
                id="hosp-patient-cat-misc-charges-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.endDate')}
                id="hosp-patient-cat-misc-charges-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.suspended')}
                id="hosp-patient-cat-misc-charges-suspended"
                name="suspended"
                data-cy="suspended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.draft')}
                id="hosp-patient-cat-misc-charges-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                id="hosp-patient-cat-misc-charges-patientCategory"
                name="patientCategory"
                data-cy="patientCategory"
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.patientCategory')}
                type="select"
              >
                <option value="" key="0" />
                {patientCategories
                  ? patientCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hosp-patient-cat-misc-charges-charge"
                name="charge"
                data-cy="charge"
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.charge')}
                type="select"
              >
                <option value="" key="0" />
                {miscCharges
                  ? miscCharges.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hosp-patient-cat-misc-charges-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.hospPatientCatMiscCharges.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/hosp-patient-cat-misc-charges"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HospPatientCatMiscChargesUpdate;
